const meIndex = resolve => {
  import(/* webpackChunkName: 'meIndex' */'../views/me/index').then(meIndex => {
    resolve(meIndex)
  })
}

const meList = resolve => {
  import('../views/me/list').then(meList => {
    resolve(meList)
  })
}
export default [{
    path: '/wechat/me',
    name: 'me',
    component: meIndex,
    meta: {
      title: '个人中心',
      requireAuth: false,
      keepAlive: false,
      footer: true
    }
  },
  {
    path: '/wechat/me/:id/list',
    name: 'course',
    component: meList,
    meta: {
      requireAuth: false,
      keepAlive: false,
      footer: false,
    }
  }
]
